import React from "react";
import "../assets/css/studentdashboard.css";

const FinancialCards = ({ totalFees, totalPayments, totalOutstanding }) => {
  return (
    <div className="financial-section">
      <div className="big-card">Total Fees: ₦{totalFees}</div>
      <div className="small-cards">
        {/* <div className="small-card">Total Payments: ₦{totalPayments}</div>
        <div className="small-card">Total Outstanding: ₦{totalOutstanding}</div> */}
      </div>
    </div>
  );
};

export default FinancialCards;
